'use strict';

angular
	.module('selfAccessRequestSharedControllers')
	.controller('ConfirmRolesRequiringAdmAccountItemController',
		['$scope', '$state',
			function ($scope, $state) {

				$scope.model = $scope.userSystemRoleDecision;
				$scope.model.confirmedForAdm = false;

				$scope.updateDecision = function() {
					$scope.model.confirmedForAdm = !$scope.model.confirmedForAdm;
				};

			}]);